import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    consultationReviewList: null,
    currentReview: null,
    isLoading: false,
  },
  actions,
  getters,
  mutations,
};
